<template>
  <div id="app">
    <router-view />
    <Chat />
  </div>
</template>

<script>
import Chat from '@/components/Chat/Chat.vue';
export default {
  name: 'App',
  components: {
    Chat,
  },
};
</script>

<style>
.el-card {
  border-color: #dedede;
}
</style>
